'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import createCache from '@emotion/cache';
import { ThemeProvider as ThemeProvider$1 } from '@emotion/react';
import { createSafeContext } from '@s7/react-utils';
import { DesignSystemError } from '@s7/system';
import { DEFAULT_THEME } from '../defaultTheme.js';
import { attachThemeHash } from './attachThemeHash.js';

const DEFAULT_CACHE = createCache({
    key: 'ds',
    prepend: true
});
/* Необходимо для прикрепления хэша */ const defaultTheme = attachThemeHash(DEFAULT_THEME);
const [ThemeContextProvider, useThemeContext] = createSafeContext(new DesignSystemError('styles', 'useTheme должен использоваться внутри ThemeProvider'), {
    cache: DEFAULT_CACHE,
    theme: defaultTheme
});
/**
 * Предоставляет доступ к контексту темы.
 *
 * Также предоставляет доступ к теме при использовании с emotion/styled,
 * оборачивая содержимое в EmotionThemeProvider.
 * */ const ThemeProvider = ({ theme = defaultTheme, cache = DEFAULT_CACHE, children })=>{
    return /*#__PURE__*/ jsx(ThemeProvider$1, {
        theme: theme,
        children: /*#__PURE__*/ jsx(ThemeContextProvider, {
            value: {
                theme,
                cache
            },
            children: children
        })
    });
};
/** Предоставляет доступ к контексту темы. */ const useTheme = ()=>useThemeContext().theme;
/** Предоставляет доступ к кэшу emotion. */ const useEmotionCache = ()=>useThemeContext().cache;

export { DEFAULT_CACHE, ThemeProvider, useEmotionCache, useTheme };
//# sourceMappingURL=ThemeProvider.js.map
